import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from "react-i18next";
import SignalRService from "src/controllers/SignalRService";
import DataGrid, { Paging, Column, FilterRow, Pager, Lookup, ColumnFixing, StateStoring } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { changeJanusStatus } from '../../redux/parametersSlice';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import Contact from './contact';
import ContactConfirmDelete from './contactconfirmdelete';
import { faPlus } from "@fortawesome/free-solid-svg-icons";

function waitForRegisterFavoritesList() {
    return new Promise((resolve) => {
        SignalRService.registerFavoritesList(e => {
            resolve(e);
        });
    });
}

function buildFilter(data) {
    let ret = "";
    if (Array.isArray(data[0])) {
        data.forEach(d => {
            let queryPart = buildFilter(d)
            if ((Array.isArray(d) && ret.indexOf(d[0]) === -1) || !Array.isArray(d))
                ret += queryPart;
        });

    } else {
        if (Array.isArray(data)) {

            //!TRAMPA JUSANIANA
            let tokens = data[0].split("_");
            let typeId = parseInt(tokens[2]);

            if ([7, 8, 17, 31].indexOf(typeId) > -1) {
                if (ret.indexOf(data[0]) === -1)
                    ret += ` (${data[0]} ge ${data[2]}) `;
            }
            else {
                ret += ` (${data[0]} eq ${data[2]}) `;
            }

        } else {
            ret = data
        }
    }

    return ret;
}

const storeFavorites = new CustomStore({
    key: 'contactId',
    async load(loadOptions) {
        let sort = "";
        let dxFitlers = loadOptions.filter ? loadOptions.filter : "";
        let filter = buildFilter(dxFitlers);

        if (filter.endsWith("and"))
            filter = filter.slice(0, -3);

        if (loadOptions.sort && loadOptions.sort.length > 0)
            sort = loadOptions.sort[0].selector + " " + (loadOptions.sort[0].desc ? "desc" : "");

        let filters = {
            "extension": localStorage.getItem("faExtension"),
            "userId": parseInt(localStorage.getItem("faUserId")),
            "skip": loadOptions.skip,
            "take": loadOptions.take,
            "sort": sort,
            "filters": filter
        }

        localStorage.setItem("fcfavoritesfilter", JSON.stringify(loadOptions));
        const registerPromise = waitForRegisterFavoritesList();
        SignalRService.getFavorites(filters);
        const result = await registerPromise;

        try {
            let data = JSON.parse(result);
            let favorites = [];

            data.result.forEach(c => {
                let contact = {
                    contactId: c.ContactId,
                    groupId: c.GroupId,
                    userId: c.AgentUserId
                };

                c.Fields.forEach(f => {
                    let id = "field_" + f.FieldId;

                    contact[id] = "";

                    if ([1, 2, 9, 10, 13, 14, 15, 20, 21, 32, 33, 34].indexOf(f.TypeId) > -1)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.StringValue;

                    if (f.TypeId === 3)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.IntValue;

                    if (f.TypeId === 4)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.FloatValue;

                    if (f.TypeId === 5)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.BoolValue;

                    if ([7, 17, 31].indexOf(f.TypeId) > -1)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.DateValue;

                    if (8 === f.TypeId && f.DateValue)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = new Date(f.DateValue).toLocaleTimeString();

                    if ([11, 12].indexOf(f.TypeId) > -1)
                        contact[`field_${f.FieldId}_${f.TypeId}`] = f.TextValue;
                });

                favorites.push(contact);
            });
            console.log(favorites);
            return {
                data: favorites,
                totalCount: data.count
            };
        } catch (err) {
            throw new Error('Data Loading Error');
        }
    },
});

class FidelityFavorites extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: [],
            selectedContactId: null,
            showContactModal: false,
            showContactConfirmDelete: false,
            action: ""
        }

        this.setFields = this.setFields.bind(this);
        this.phoneCell = this.phoneCell.bind(this);
        this.emailCell = this.emailCell.bind(this);
        this.listCell = this.listCell.bind(this);
        this.toggleContactModal = this.toggleContactModal.bind(this);
        this.toggleContactConfirmDelete = this.toggleContactConfirmDelete.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.reloadFavorites = this.reloadFavorites.bind(this);

        this.dataGridRef = createRef();
    }

    componentDidMount() {
        SignalRService.registerAddressBookFields(this.setFields);
        setTimeout(() => {

            SignalRService.getAddressBookFields({ userId: this.props.userId, extension: this.props.extension }, (error) => { });
        }, 500);
    }

    componentDidUpdate() {

        if (this.props.reload) {

            this.reloadFavorites();
            this.props.loaded();
        }
    }

    setFields = data => {

        let fields = [{
            fieldId: "contactId",
            name: "contactId",
            type: "number",
            values: null
        }];
        let pages = JSON.parse(data);

        pages.forEach(page => {

            page.Fields.forEach(v => {
                let type = "string";

                if (v.Type === "BOOLEAN")
                    type = "boolean";

                if (v.Type === "DATE")
                    type = "date";

                if (v.Type === "DATETIME")
                    type = "datetime";

                if (v.Type === "TIME")
                    type = "time";

                if (v.Type === "NUMERIC" || v.Type === "FLOAT")
                    type = "number";

                fields.push({
                    fieldId: `field_${v.FieldId}_${v.TypeId}`,
                    name: v.Name,
                    type: type,
                    typeId: v.TypeId,
                    values: v.Values
                });
            });

        });

        this.setState({ fields: fields });
    }

    phoneCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href="/#" onClick={(e) => {
                e.preventDefault();
                this.props.changeJanusStatus("makeCall");
                SignalRService.makeCall({
                    "extension": this.props.extension,
                    "userId": this.props.userId,
                    "called": dataCell.value
                });
            }}>{dataCell.value}</a>
        )
    }

    emailCell = dataCell => {
        return (
            (dataCell.value) &&
            <a className={""} href={`mailto:${dataCell.value}`}>{dataCell.value}</a>
        )
    }

    listCell = dataCell => {
        return dataCell.text || ""
    }

    editCell = dataCell => {
        return (
            ((dataCell.data.userId !== null && dataCell.data.groupId === null) || 
            (dataCell.data.userId === null && dataCell.data.groupId !== null && this.props.functions.permissions.groupAlter) ||
            (dataCell.data.userId === null && dataCell.data.groupId === null && this.props.functions.permissions.globalAlter)) &&
            <Button variant={""} size='sm' className={"text-primary"} onClick={() => {
                this.setState({
                    selectedContactId: dataCell.data.contactId,
                    action: "editcontact",
                    showContactModal: true
                });
            }}>
                <FontAwesomeIcon icon={duotone("pen-to-square")} />
            </Button>
        );
    }

    deleteCell = dataCell => {
        return (
            ((dataCell.data.userId !== null && dataCell.data.groupId === null) || 
            (dataCell.data.userId === null && dataCell.data.groupId !== null && this.props.functions.permissions.groupDelete) ||
            (dataCell.data.userId === null && dataCell.data.groupId === null && this.props.functions.permissions.globalDelete)) &&
            <Button variant={""} size='sm' className={"text-primary"}
                onClick={e => {
                    this.deleteContact(dataCell.data.contactId)
                }}>
                <FontAwesomeIcon icon={solid("trash-can")} style={{ color: "#b55050" }} />
            </Button>
        );
    }

    toggleContactModal() {

        this.setState({ showContactModal: !this.state.showContactModal, action: "addcontact" });
    }

    toggleContactConfirmDelete() {
        this.setState({ showContactConfirmDelete: !this.state.showContactConfirmDelete });
    }

    deleteContact = contactId => {
        this.setState({
            selectedContactId: contactId
        });
        this.toggleContactConfirmDelete();
    }

    reloadFavorites = () => {
        if (this.dataGridRef.current)
            this.dataGridRef.current.instance.refresh();
    }

    render() {
        return (
            <div style={{ position: "relative", right: "10px" }}>
                <Button size='sm' variant="primary" onClick={this.toggleContactModal} className="position-absolute fs-6" style={{ right: 0, top: -40 }}>
                    <FontAwesomeIcon icon={faPlus} /> {this.props.t("addcontact")}
                </Button>
                {
                    (this.state.fields != null && this.state.fields.length > 0) &&
                    <DataGrid
                        dataSource={storeFavorites}
                        id="fidelityfavoritestable"
                        noDataText=""
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        row
                        height={"74vh"}
                        width={"100%"}
                        ref={this.dataGridRef}
                        allowColumnResizing={true}
                    >
                        {this.state.fields.map(x => {
                            let column = <Column dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 1)
                                column = <Column cellRender={this.phoneCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 10)
                                column = <Column cellRender={this.emailCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} />

                            if (x.typeId === 9)
                                column = <Column cellRender={this.listCell} dataField={x.fieldId} cssClass={"align-middle"} dataType={x.type} caption={x.name} width={150} visible={x.fieldId !== "contactId"} >

                                    <Lookup className="field-customization"
                                        dataSource={x.values}
                                        valueExpr="Value"
                                        displayExpr={e => {
                                            return this.props.t(e.Description);
                                        }}
                                    />
                                </Column>
                            return column;
                        })
                        }
                        <Column caption={""} cellRender={this.editCell} width={60} cssClass={"align-middle"} fixed={true} fixedPosition="right" />
                        <Column caption={""} cellRender={this.deleteCell} width={60} cssClass={"align-middle"} fixed={true} fixedPosition="right" />
                        <ColumnFixing enabled={true} />
                        <FilterRow visible={true} applyFilter={"auto"} showOperationChooser={false} className={"form-control"} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[5, 9, 12, 15]}
                            showInfo={true}
                            showNavigationButtons={true}
                            infoText={this.props.t("pager")}
                        />
                        <Paging defaultPageSize={12} />
                        <StateStoring
                            enabled={true}
                            type="localStorage"
                            storageKey={`fcFavorites_${this.props.userId}`}
                        />
                    </DataGrid>
                }
                <Contact show={this.state.showContactModal} toggleModal={this.toggleContactModal} action={this.state.action} contactId={this.state.selectedContactId} reload={this.reloadFavorites}></Contact>
                <ContactConfirmDelete show={this.state.showContactConfirmDelete} toggleModal={this.toggleContactConfirmDelete} contactId={this.state.selectedContactId} reload={this.reloadFavorites}></ContactConfirmDelete>
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId,
        functions: state.agent.functions
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus }), withTranslation())(FidelityFavorites);
